/**
 * Controller: TemplatesCreatePricingTicketsRules
 */
angular.module('acme.application.templates.create.pricing.ticketsRules.controllers', [
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.templates',
    'acme.common.directive.feature',
    'acme.common.factory.wizard',
  ])
  .controller('TemplatesCreatePricingTicketsRulesController', [
    '$scope',
    '$timeout',
    'HelpersService',
    'ApiService',
    'TemplatesService',
    'ValidateService',
    'WizardFactory',
    '$window',
    function($scope,
      $timeout,
      HelpersService,
      ApiService,
      TemplatesService,
      ValidateService,
      WizardFactory,
      $window) {

      var CONSTANTS = {
        ERROR: {
          NO_TICKET_TYPE: 'At least one ticket type is required.',
          TICKET_TYPE: 'You can have only one limit per ticket type.',
          QUANTITY: 'Limit is required.',
          TIME_FRAME: 'Limit per day cannot be larger than per event',
          PLEASE_WAIT: 'Please wait...',
          PRICE_POINT: 'price-point',
          NO_QUANTITY: 'quantity'
        },
      };

      $scope.templatesCreatePricingTicketsRules = {

        template: {},
        entitlementConfiguration: {},
        hasTicketsRules: false,
        prices: [],
        ticketsRules: [],

        multiSelectTicketLabels: {
          selectAll: "Select all",
          selectNone: "Select none",
          search: "Search by ticket type name...",
          nothingSelected: "Select a ticket type"
        },

        wizard: {},

        init: function() {

          this.initWizard(true);

          ValidateService.addFieldTests(this.wizard.getStep('tickets').validators);

          $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
          $scope.$on('TemplatesCreateController::Save', this.onTemplatesCreateControllerSave);
          $scope.$on('TemplatesCreatePricing::Update', this.onTemplatesCreatePricingUpdate);

          this.getPrices();
        },

        // VALIDATE
        initWizard: function(validate) {
          var self = $scope.templatesCreatePricingTicketsRules;

          this.wizard = new WizardFactory();
          this.wizard.init({
            name: 'tickets',
            validators: [
              {
                field: 'templates-create-pricing-tickets-rule-conflicting-validator',
                equal: {
                  message: 'NO_MESSAGE',
                  test: function () {
                    return [!self.ticketsRules._hasError, true];
                  }
                }
              }, {
                field: 'templates-create-pricing-tickets-rule-conflicting',
                equal: {
                  message: 'NO_MESSAGE',
                  test: function () {
                    return [true, true];
                  }
                }
              },
              {
                field: 'templates-create-pricing-tickets-rule-pricepoint-incomplete',
                equal: {
                  message: CONSTANTS.ERROR.NO_TICKET_TYPE,
                  test: function () {
                    var hasIncompleteRules = self.ticketsRules.filter(function(rule) {
                      var hasTicketType = rule.selectedPricepoints.length > 0,
                          error = false;

                      if(!hasTicketType) {
                        error = true;
                        rule._errors = [CONSTANTS.ERROR.PRICE_POINT].concat(rule._errors);
                      }

                      return error;
                    }).length > 0;

                    return [!hasIncompleteRules, true];
                  }
                }
              },
              {
                field: 'templates-create-pricing-tickets-rule-pricepoint-quantity',
                equal: {
                  message: CONSTANTS.ERROR.QUANTITY,
                  test: function () {
                    var hasCeroQuantity = self.ticketsRules.filter(function(rule) {
                      var hasErrorQuantity = !!rule.quantity,
                          error = false;

                      if(!hasErrorQuantity) {
                        error = true;
                        rule._errors = [CONSTANTS.ERROR.NO_QUANTITY].concat(rule._errors);
                      }

                      return error;
                    }).length > 0;

                    return [!hasCeroQuantity, true];
                  }
                }
              }
            ]
          });

          if (validate) {
            this.validate();
          }
        },

        validate: function () {
          $timeout(function () {
            var self = $scope.templatesCreatePricingTicketsRules;

            self.ticketsRules.forEach(function(rule) {
              rule._errors = [];
            });

            self.ticketsRules._hasError = self.runTicketsRulesValidation();
            self.wizard.validate();

            $scope.$emit('TemplatesCreatePricingController::TabCheck', {
              tab: 'tickets',
              invalid: self.wizard.hasErrors('tickets')
            });
          }, 0);
        },

        hasErrors: function() {
          return this.wizard.hasErrors('tickets');
        },

        runTicketsRulesValidation: function() {
          var self = $scope.templatesCreatePricingTicketsRules,
              pricePointOcurrences = {},
              hasErrors = false;

          self.ticketsRules.forEach(function(rule, i) {
            rule.selectedPricepoints.forEach(function(item) {
              if (pricePointOcurrences.hasOwnProperty(item.id)) {
                pricePointOcurrences[item.id]++;
                hasErrors = true;
              } else {
                pricePointOcurrences[item.id] = 0;
              }
            });
          });

          self.ticketsRules.forEach(function(rule, i) {
            var current = rule;
            rule.selectedPricepoints.forEach(function(item) {
              if (pricePointOcurrences[item.id]) {
                current._errors = [CONSTANTS.ERROR.PRICE_POINT].concat(current._errors);
              }
            });
          });

          step = 'tickets',
          validator = 'templates-create-pricing-tickets-rule-conflicting';
          errorMessage = CONSTANTS.ERROR.TICKET_TYPE;

          this.wizard.removeValidator(step, validator);
          this.wizard.addValidator(step, {
            field: validator,
            equal: {
              message: errorMessage,
              test: function() {
                return [!hasErrors, true];
              }
            }
          });

          return hasErrors;
        },

        // INIT
        onTemplatesServiceUpdate: function(e, data) {
          var self = $scope.templatesCreatePricingTicketsRules;
          self.template = TemplatesService.getModel();
        },

        onTemplatesCreateControllerSave: function(e, data) {
          var self = $scope.templatesCreatePricingTicketsRules;

          // APP-5100: Diagnostic — detect when marshall() produces an empty ticketRuleConfig
          // even though existing rules were present. The tab-switch auto-save in
          // onTemplatesCreatePricingUpdate is guarded by ticketsRules.length, but this handler
          // is also bound directly to the global TemplatesCreateController::Save broadcast,
          // which is unguarded: a save landing before getPrices/loadTicketsRules populates
          // self.ticketsRules wipes the config in memory before it is persisted.
          var previousConfig = self.entitlementConfiguration ? self.entitlementConfiguration.ticketRuleConfig : null;
          var hadExistingRules = previousConfig instanceof Array && previousConfig.length > 0;
          var marshalled = self.marshall();
          var marshalledIsEmpty = !marshalled || marshalled.length === 0;

          if (hadExistingRules && marshalledIsEmpty) {
            var metadata = {
              previousTicketRuleConfigCount: previousConfig.length,
              ticketsRulesInMemoryCount: self.ticketsRules ? self.ticketsRules.length : 0,
              templateId: self.template ? self.template.id : null,
            };

            console.warn('[APP-5100] marshall() produced empty ticketRuleConfig — existing ticket rules will be wiped:', metadata);

            if ($window.Bugsnag) {
              $window.Bugsnag.notify(
                new Error('[APP-5100] marshall() produced empty ticketRuleConfig — existing ticket rules will be wiped'),
                function (event) {
                  event.context = 'templates.pricing.tickets.rules_wiped_on_update';
                  event.severity = 'warning';
                  event.addMetadata('ticketsRulesState', metadata);
                }
              );
            }
          }

          self.entitlementConfiguration.ticketRuleConfig = marshalled;
          TemplatesService.setTicketsRules(self.entitlementConfiguration.ticketRuleConfig);

          self.validate();
        },

        onTemplatesCreatePricingUpdate: function(e, data) {
          var self = $scope.templatesCreatePricingTicketsRules;

          self.template = TemplatesService.getModel();

          if (self.template.id) {
            $timeout(function () {
              if (self.ticketsRules && self.ticketsRules.length) {
                self.onTemplatesCreateControllerSave();
                self.getPrices();
              } else {
                self.getPrices();
              }
            });
          }
        },

        getPrices: function() {
          return ApiService.price.types.list(HelpersService.getPaginator()).then(this.success.getPrices, this.error.getPrices);
        },

        _orderByBusinessRules: function(a, b) {
          var displayNameA = a.displayName || a.name || '',
            displayNameB = b.displayName || b.name || '';

          return displayNameA.toUpperCase() > displayNameB.toUpperCase() ? 1 : -1;
        },

        // ADD
        addTicketsRule: function() {
          this.ticketsRules.push({
            quantity: '',
            allPricepoints: this.selectPricepoints(),
            selectedPricepoints: []
          });
          this.checkTicketsRules();
        },

        selectPricepoints: function (list) {
          return this._selectItems(this.prices, list);
        },

        _selectItems: function(allItems, givenItems) {
          var hash = this._buildHash(givenItems),
            _allItems = allItems || [];

          return _allItems.map(function(item) {
            return Object.assign({}, item, {
              ticked: !!hash[item.id]
            });
          });
        },

        _buildHash: function(list) {
          var _list = list || [];

          return _list.reduce(function(hash, item) {
            hash[item.id] = item;

            return hash;
          }, {});
        },

        checkTicketsRules: function() {
          if (this.ticketsRules.length <= 0) {
            this.hasTicketsRules = false;
          } else {
            this.hasTicketsRules = true;
          }
        },

        validateQuantity: function(rule) {
          rule.quantity = parseInt(rule.quantity, 10) || 0;
        },

        removeTicketsRule: function(index) {
          this.ticketsRules.splice(index, 1);
          this.checkTicketsRules();
        },

        // MARSHALL
        marshall: function() {
          var self = $scope.templatesCreatePricingTicketsRules,
              ticketsRules,
              ticketRuleConfig;

          ticketsRules = self.ticketsRules.map(function(rule) {
            return {
              pricepointInfo: rule.selectedPricepoints.map(function(pricepoint) {
                var pricepointInfo = self.findPricePoint(pricepoint.id);
                return pricepointInfo ? {
                  id: pricepointInfo.pricepoint.id,
                  name: pricepointInfo.pricepoint.name
                } : null;
              }).filter(function(princepoint) {
                return princepoint;
              }),
              quantity: rule.quantity
            };
          });

          ticketRuleConfig = ticketsRules.map(function(rule) {
            var result = {
              acrossOrder: true,
              quantity: rule.quantity
            };

            if(rule.pricepointInfo.length > 0 ) {
              result.pricepoints = {
                pricepointInfo: rule.pricepointInfo,
                ruleApplies: "acrossAllItems"
              };
            }

            return result;
          });

          return ticketRuleConfig;
        },

        findPricePoint: function (id) {
          var i, ii,
            r = false;

          for (i = 0, ii = this.prices.length; i < ii; i++) {
            if (id === this.prices[i].id) {
              r = {
                index: i,
                pricepoint: this.prices[i]
              };
              break;
            }
          }

          return r;
        },

        // LOAD
        loadTicketsRules: function() {
          var entitlementConfiguration = this.template.entitlementConfiguration;

          this.entitlementConfiguration = TemplatesService.getEntitlement(true);
          this.ticketsRules = this.process(this.entitlementConfiguration.ticketRuleConfig);
        },

        process: function(ticketRuleConfig) {
          var self = $scope.templatesCreatePricingTicketsRules;

          ticketRuleConfig = ticketRuleConfig || [];

          angular.forEach(ticketRuleConfig, function(rule) {
            var hasPricePoints = false,
                pricepoints = rule.pricepoints;

            hasPricePoints = (pricepoints && pricepoints.pricepointInfo instanceof Array) && pricepoints.pricepointInfo.length;
            rule.selectedPricepoints = hasPricePoints ? pricepoints.pricepointInfo : [];
            rule.allPricepoints = self.selectPricepoints(hasPricePoints ? pricepoints.pricepointInfo : []);
          });

          return ticketRuleConfig;
        },

        success: {
          getPrices: function(response) {
            var self = $scope.templatesCreatePricingTicketsRules,
              prices = response &&
              response.data &&
              response.data.payload &&
              response.data.payload.list || [];

            self.prices = prices.sort(self._orderByBusinessRules);
            self.loadTicketsRules();
            self.checkTicketsRules();
          }
        },

        error: {
          getPrices: function(response) {}
        }

      };

      $scope.templatesCreatePricingTicketsRules.init();
    }
  ]);
